<app-payment-card-details number="4" [active]="active.active === 'firstPayment'"
    [complete]="vm.slides.cardDetailsComplete" [cardDetailsHeading]="firstPaymentContent.cardDetailsHeading"
    [cardDetailsSubHeading]="firstPaymentContent.cardDetailsSubHeading"
    [cardDetailsBody]="firstPaymentContent.cardDetailsBody"
    [paySecurelyButtonText]="firstPaymentContent.paySecurelyButtonText"
    [failedPaymentMessage]="firstPaymentContent.failedPaymentMessage"
    [errorPaymentMessage]="firstPaymentContent.errorPaymentMessage"
    [processingPaymentTitle]="firstPaymentContent.processingPaymentTitle"
    [processingPaymentBody]="firstPaymentContent.processingPaymentBody"
    [paymentCardPageUrl]="firstPaymentContent.paymentCardPageUrl" (BackEvent)="back()" (CompleteEvent)="save()">
</app-payment-card-details>